exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".no-menu[data-v-2e2a12d0]{padding-top:0}.full-menu[data-v-2e2a12d0],.mid-menu[data-v-2e2a12d0]{padding-top:63px}.username[data-v-2e2a12d0]{position:absolute;bottom:5px;right:20px}.catalog[data-v-2e2a12d0]{position:absolute;width:120px;height:38px;right:200px;background-color:#d72429;border:0;color:#fff}.catalogoption[data-v-2e2a12d0]{font-size:.8em;font-weight:400}.close[data-v-2e2a12d0]{z-index:10;padding-top:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e2a12d0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./scss/cattelan/_wp_variables.scss","./node_modules/bootstrap/scss/_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/custom/cattelan/startFrame.vue
// module id = 1656
// module chunks = 163 164 169